<div class="layout-content">
	<div *ngIf="exporting" class="flex align-items-center justify-content-center w-full">
		<p-progressSpinner ariaLabel="loading"></p-progressSpinner>
	</div>
	<form *ngIf="!exporting" (ngSubmit)="submit()" [formGroup]="finalUserListForm">
		<div class="grid">
			<div class="col-12 flex justify-content-center text-center bg-blue-200 py-0 border-round-xl">
				<p-tag icon="pi cm-alert" value="{{ 'INFO_EXPORT_FINAL_USERS' | translate }}" severity="info" styleClass="text-lg"></p-tag>
			</div>
			<div class="col-12 mt-3">
				<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.name, 'borderRow')">
					<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.name, 'label')">{{ 'NAME_LIST_FINAL_USERS' | translate }}</div>
					<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.name, 'borderInput')">
						<input type="text" pInputText
							[ngClass]="dynamicInputTextWidth()"
							id="scenery-add-input-name"
							formControlName="name"
							autocomplete="scenery-name"
							placeholder="{{ 'NAME_LIST_FINAL_USERS' | translate }}"
							maxlength="26"
						/>
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.name)" class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
		</div>

		<div class="grid mt-5 mx-1 flex justify-content-center align-items-center">
			<button type="submit" pButton pRipple
				label="{{ 'CONFIRM' | translate }}"
				class="p-button-primary text-xl font-normal mx-2 mb-1"
				[ngClass]="dynamicButtonWidth()">
			</button>
			<button type="button" pButton pRipple (click)="closeDialog()"
				label="{{ 'CANCEL' | translate }}"
				class="p-button-secondary text-xl font-normal mx-2 mb-1"
				[ngClass]="dynamicButtonWidth()">
			</button>
		</div>
	</form>
</div>